/*
  <card-title-clamp> — clamps a product card title to N lines and, when the
  title is truncated, lays a transparent tap target over it. Tapping expands
  the full title in place instead of navigating to the product.
*/
(function () {
  if (customElements.get('card-title-clamp')) return;

  class CardTitleClamp extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('.card-title-clamp__text');
      this.toggle = this.querySelector('.card-title-clamp__toggle');
      if (!this.text || !this.toggle) return;

      this.checkOverflow();

      this.toggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const expanded = this.classList.toggle('is-expanded');
        this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        this.toggle.setAttribute(
          'aria-label',
          expanded ? 'Hide full title' : 'Show full title'
        );
      });

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => {
          if (!this.classList.contains('is-expanded')) this.checkOverflow();
        });
        this.observer.observe(this.text);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    checkOverflow() {
      const overflowing = this.text.scrollHeight > this.text.clientHeight + 1;
      this.toggle.hidden = !overflowing;
    }
  }

  customElements.define('card-title-clamp', CardTitleClamp);
})();

/*
  Card click → product page.
  Sense normally makes the whole product card clickable via an invisible
  overlay on the title link (.card__heading a::after). The <card-title-clamp>
  wrapper above establishes a positioning context that traps that overlay
  inside the title, so clicks on the image (and elsewhere on the card) stopped
  navigating. This restores it robustly: a click anywhere on a product card
  opens its product page, EXCEPT on genuine controls (quick-add, the title
  expand toggle, real links/buttons/form fields), which keep their behaviour.
  Modifier / middle clicks open the product in a new tab.
*/
(function () {
  if (window.__cardClickLinkInit) return;
  window.__cardClickLinkInit = true;

  var INTERACTIVE =
    'a, button, input, select, textarea, label, summary, [role="button"], ' +
    '.card-title-clamp__toggle, modal-opener, modal-dialog, quick-add-modal, ' +
    'product-form, quick-add-bulk, quantity-popover, .quick-add, ' +
    '.card__information-volume-pricing-note';

  var style = document.createElement('style');
  style.textContent = '.card-wrapper .card__media { cursor: pointer; }';
  document.head.appendChild(style);

  function cardHref(wrapper) {
    var link = wrapper.querySelector('.card__heading a[href]');
    return link ? link.getAttribute('href') : null;
  }

  function handle(event, forceNewTab) {
    if (event.button === 2) return;
    var wrapper = event.target.closest('.card-wrapper');
    if (!wrapper) return;
    if (event.target.closest(INTERACTIVE)) return;

    var href = cardHref(wrapper);
    if (!href) return;

    var newTab =
      forceNewTab || event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1;
    event.preventDefault();
    if (newTab) {
      window.open(href, '_blank', 'noopener');
    } else {
      window.location.assign(href);
    }
  }

  document.addEventListener('click', function (e) {
    handle(e, false);
  });
  document.addEventListener('auxclick', function (e) {
    if (e.button === 1) handle(e, true);
  });
})();
